import React from 'react';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { getWordAndCharacterCount } from '../utils/getWordAndCharacterCount';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import wordCountSvg from '../../../assets/icons/wordCount.svg';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import CompactWordCount from '../components/WordCount';

class ToolWordCount extends Tool {
  static toolName = 'Word count';

  // The word count displays on hover, so we don't need an action
  static action() {}

  static renderToolbarButtonIcon() {
    return svgToIcon(wordCountSvg);
  }

  static tooltip() {
    return '';
  }

  static renderToolbarComponent(toolArgs: ToolArgsWithController): JSX.Element {
    const { editor } = toolArgs;
    const { words, characters } = getWordAndCharacterCount(editor);

    return (
      <aha-menu trigger="hover">
        <div slot="control">
          <div
            className={styles.toolbarButton}
            aria-selected={this.isActive(toolArgs)}
            aria-disabled={!this.isEnabled(toolArgs)}
          >
            {svgToIcon(wordCountSvg)}
          </div>
        </div>
        <aha-menu-content style={{ minWidth: '108px' }}>
          <CompactWordCount words={words} characters={characters} />
        </aha-menu-content>
      </aha-menu>
    );
  }
}

export default ToolWordCount;
